import React, { useState } from "react";
import api from "../../api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { FaLock } from "react-icons/fa";

const PasswordChangeModal = ({ onClose }) => {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put("/users/change-password", { password });
      toast.success(t("user.passwordChanged"));
      onClose();
    } catch {
      toast.error(t("user.passwordError"));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 bg-base-100 rounded-2xl border border-base-200 shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b border-base-200">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
              <FaLock className="w-4 h-4" />
            </div>
            <h2 className="text-lg font-bold text-base-content">{t("user.changePassword")}</h2>
          </div>
          <button onClick={onClose} className="btn btn-ghost btn-sm btn-square text-base-content/40">✕</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="p-6">
            <label className="block text-sm font-medium text-base-content/70 mb-1">{t("user.newPassword")}</label>
            <input
              type="password"
              placeholder={t("user.enterNewPassword")}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input input-bordered bg-base-200 border-base-300 text-base-content focus:border-primary focus:outline-none w-full placeholder:text-base-content/40"
              required
            />
          </div>
          <div className="flex justify-end gap-2 px-6 py-4 border-t border-base-200">
            <button onClick={onClose} type="button" className="btn btn-ghost">{t("buttons.cancel")}</button>
            <button type="submit" className="btn btn-primary">{t("user.update")}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PasswordChangeModal;
